export default __webpack_public_path__ + "static/media/desktop.2ca0b63d.jpg";